module.exports = __webpack_public_path__ + "img/yj_prize_btn_bg.49d7dc1b.png";